import React, { useEffect, useState } from "react";
import reactDom from "react-dom";
import "./appDialog.css";
import utils from "../../Utils";
import classNames from "classnames";
import { t } from "../../Utils/translate";

import { RiArrowLeftLine, RiCloseLine } from "react-icons/ri";

function AppDialog({
  view,
  setVisibility,
  dialogTitle,
  dialogPositiveBtnText,
  dialogNegativeBtnText,
  isBackNavigation,
  callBackNavigation,
  dialogPositiveBtnCall,
  dialogNegativeBtnCall,
  widthType,
  disablePositiveBtn,
  sideView,
  enterDisabled,
}) {
  const [title, setTitle] = useState(dialogTitle);
  const [positiveBtnText, setPositiveBtnText] = useState(dialogPositiveBtnText);
  const [negativeBtnText, setNegativeBtnText] = useState(dialogNegativeBtnText);
  const [containerId, setContainerId] = useState("");
  const [dialogId, setDialogId] = useState("");
  const [isBackVisible, seIsBackVisible] = useState(false);
  const [dialogType, setDialogType] = useState("");
  const [disablePositiveBtnState, setDisablePositiveBtnState] = useState(false);
  useEffect(() => {
    if (dialogTitle != null && dialogTitle != "") {
      setTitle(dialogTitle);
    }
    setPositiveBtnText(dialogPositiveBtnText);

    setNegativeBtnText(dialogNegativeBtnText);

    if (isBackNavigation != null) {
      seIsBackVisible(isBackNavigation);
    }
    setContainerId(Math.random().toString(36).slice(2));
    setDialogId(Math.random().toString(36).slice(2));

    if (
      (widthType && widthType === utils.constants.dialogWidthType.small) ||
      widthType === utils.constants.dialogWidthType.regular ||
      widthType === utils.constants.dialogWidthType.big
    ) {
      setDialogType(widthType);
    }
    setDisablePositiveBtnState(disablePositiveBtn);
  }, [disablePositiveBtn, dialogPositiveBtnText, dialogNegativeBtnText]);
  document.onkeydown = function (evt) {
    if (enterDisabled === true) {
    } else {
      evt = evt || window.event;
      let isEscape = false;
      if ("key" in evt) {
        isEscape = evt.key === "Escape" || evt.key === "Esc";
      } else {
        isEscape = evt.keyCode === 27;
      }
      if (isEscape) {
        close();
      }
      const code = evt.keyCode ? evt.keyCode : evt.which;
      if (code === 13) {
        dialogPositiveBtnCall();
      }
    }
  };

  function close() {
    if (document.getElementById(dialogId)) {
      document.getElementById(dialogId).classList.add("popout");
      document.getElementById(containerId).classList.add("bg-close");
      setTimeout(() => {
        setVisibility(false);
      }, 500);
    }
  }

  function back() {
    callBackNavigation();
  }

  return reactDom.createPortal(
    <div className={"dialog-container"} style={{ zIndex: "9999" }}>
      <div
        className={classNames("dialog-sub-container", sideView ? "dialog-sub-container-side" : "dialog-sub-container-center")}
        onClick={(e) => {
          if (e.target.className === "dialog-container") {
            close();
          }
        }}
        id={containerId}
      >
        <div className={classNames("dialog", "dialog-small")} id={dialogId}>
          <header className="dialog-header" onClick={() => { }}>
            {/* <RiArrowLeftLine onClick={() => back()} style={{ display: isBackVisible ? "flex" : "none" }} className="icon-class" /> */}
            <heading>{title}</heading>
            <RiCloseLine
              onClick={(e) => {
                // dialogNegativeBtnCall()
                close();
              }}
              className="icon-class dialog-close icon-hover-bg close-icon-absolute"
            />
          </header>
          <div className="dialog-body">{view}</div>
          <footer className="dialog-footer">
            {negativeBtnText != null && negativeBtnText != "" ? (
              <button onClick={() => dialogNegativeBtnCall()} className="dialog-btn dialog-btn-type-bordered">
                {negativeBtnText}
              </button>
            ) : null}
            {positiveBtnText != null && positiveBtnText != "" ? (
              <button
                onClick={() => {
                  if (!disablePositiveBtnState) {
                    dialogPositiveBtnCall();
                    // close()
                  }
                }}

                className={classNames("dialog-btn dialog-btn-type-filled")}

                disabled={disablePositiveBtnState} // Disable the button if leaveReason is empty
                style={{
                  backgroundColor: disablePositiveBtnState ? "rgba(128, 128, 128, 0.3)" : "green", // Transparent grey if disabled, green if enabled
                  color: disablePositiveBtnState ? "rgba(255, 255, 255, 0.6)" : "white",  // Dimmed text when disabled
                  cursor: disablePositiveBtnState ? "not-allowed" : "pointer",  // Change cursor when disabled
                  boxShadow: disablePositiveBtnState ? "0px 4px 8px rgba(128, 128, 128, 0.5)" : "0px 4px 8px rgba(0, 128, 0, 0.4)", // Grey shadow if disabled, green shadow if enabled
                  opacity: disablePositiveBtnState ? 0.6 : 1, // Slight opacity change when disabled
                  transition: "0.3s ease"  // Smooth transition for background and shadow changes
                }}
              >
                {positiveBtnText}
              </button>
            ) : null}
          </footer>
        </div>
      </div>
    </div>,
    document.getElementById("root")
    //     <div>
    //     <p>Consultaion charges:</p>
    //     <input type="text" id="consultationAmount" placeholder="Enter amount" ></input>
    // </div>
  );
}

export default AppDialog;
